export const legalNoticeStrings = {
    en:{
        legalNoticeTitle: "Legal Notice",
        legalNoticeTitle1: "General Information",
        legalNoticeContent1: "This website is owned by \"APLINSoft - Wojciech Nowogrodzki\" with its registered office in Marki. Contact with the website owner is possible at the e-mail address: wojciech!nowogrodzki.pl (replace ! with @).",
        legalNoticeTitle2: "Copyright and Trademarks",
        legalNoticeContent2: "All materials available on the website, including texts, graphics, photos, logos, and other visual elements, are protected by copyright and belong to \"APLINSoft - Wojciech Nowogrodzki\" or are used under appropriate licenses. Copying, distributing, or using these materials in any way without the owner's consent is prohibited.",
        legalNoticeTitle3: "Disclaimer of Liability",
        legalNoticeContent3: "The information contained on the website is for informational purposes only and does not constitute a commercial offer within the meaning of the Civil Code provisions. \"APLINSoft - Wojciech Nowogrodzki\" is not responsible for errors in the content or for decisions made based on it.",
        legalNoticeTitle4: "Privacy Policy and Cookies",
        legalNoticeContent4: "The use of the website may involve saving cookie files on the user's device to improve the functionality of the service. The website does not process or store any data allowing user identification.",
        legalNoticeTitle5: "Changes to the Legal Notice",
        legalNoticeContent5: "\"APLINSoft - Wojciech Nowogrodzki\" reserves the right to make changes to this legal notice. Users are obliged to regularly familiarize themselves with its content."
    },
    pl: {
        legalNoticeTitle:"Nota prawna",
        legalNoticeTitle1:"Informacje ogólne",
        legalNoticeContent1:"Niniejsza strona internetowa jest własnością \"APLINSoft - Wojciech Nowogrodzki\" z siedzibą w Markach. Kontakt z właścicielem strony możliwy jest pod adresem e-mail: wojciech!nowogrodzki.pl (w miejsce ! należy wstawić @).",
        legalNoticeTitle2:"Prawa autorskie i znaki towarowe",
        legalNoticeContent2:"Wszystkie materiały dostępne na stronie, w tym teksty, grafiki, zdjęcia, logotypy oraz inne elementy wizualne, są chronione prawem autorskim i należą do \"APLINSoft - Wojciech Nowogrodzki\" lub są wykorzystywane na podstawie odpowiednich licencji. Kopiowanie, rozpowszechnianie lub wykorzystywanie tych materiałów w jakikolwiek sposób bez zgody właściciela jest zabronione.",
        legalNoticeTitle3:"Zastrzeżenie odpowiedzialności",
        legalNoticeContent3:"Informacje zawarte na stronie mają charakter informacyjny i nie stanowią oferty handlowej w rozumieniu przepisów Kodeksu cywilnego. \"APLINSoft - Wojciech Nowogrodzki\" nie ponosi odpowiedzialności za błędy w treściach, ani za decyzje podjęte na ich podstawie.",
        legalNoticeTitle4:"Polityka prywatności i pliki cookies",
        legalNoticeContent4:"Korzystanie ze strony może wiązać się z zapisywaniem plików cookies na urządzeniu użytkownika w celu poprawy funkcjonalności serwisu. Strona nie przetwarza i nie przechowuje żadnych danych pozwalających na identyfikację użytkownika.",
        legalNoticeTitle5:"Zmiany w notach prawnych",
        legalNoticeContent5:"\"APLINSoft - Wojciech Nowogrodzki\" zastrzega sobie prawo do wprowadzania zmian w niniejszej nocie prawnej. Użytkownicy są zobowiązani do regularnego zapoznawania się z jej treścią.",
    },
};

export default legalNoticeStrings;















